import { Col, Container, Image, Row } from "react-bootstrap"
import bgHome from '../img/bgHome.png'

function DashboardAdminOperation({t}){
    return (
        <Container fluid>
            <Row>
                <Col xs="12" md="6" className="px-0" >                    
                    <div className="position-relative">
                        <div className="bg-info-1">
                            <div className="p-5">
                                <h3 className="text-white">Ahorre tiempo en la gestión de su consultorio</h3>
                                <p className="text-white my-4">La herramienta definitiva para la gestión de las visitas y la comunicación con sus pacientes. Ahora, también, con servicio de consultas en línea por videollamada.
                                </p>

                                
                            </div>
                        </div>  
                    </div>                    
                </Col>
                <Col xs="12" md="6" className="d-md-block d-none px-0">
                    <Image src={bgHome} fluid />
                </Col>
            </Row>
        </Container>
    )
}

export default DashboardAdminOperation